// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-popup-container-index-module__popup-container-pPsR2Q {
  flex-direction: column;
  display: flex;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-popup-container-index-module__popup-container-id-CJBPL5 {
  position: relative;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-popup-container-index-module__popup-container-id-CJBPL5 .semi-portal-inner {
  width: 100%;
  top: 2px !important;
  left: 0 !important;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popup-container": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-popup-container-index-module__popup-container-pPsR2Q`,
	"popupContainer": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-popup-container-index-module__popup-container-pPsR2Q`,
	"popup-container-id": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-popup-container-index-module__popup-container-id-CJBPL5`,
	"popupContainerId": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-popup-container-index-module__popup-container-id-CJBPL5`
};
export default ___CSS_LOADER_EXPORT___;
